// extracted by mini-css-extract-plugin
export default {"topContainer":"altParking_topContainer__oI7zV","btns":"altParking_btns__Hg-xP","title":"altParking_title__nxi4Z"};